import { motion } from "framer-motion";

// Premium Duotone Icon System - Filled, Soft 3D Style
// Each icon has a primary and secondary color layer

export function IconScript({ className = "", size = 24, active = false }) {
  const primary = active ? "var(--color-gold-400)" : "var(--text-secondary)";
  const secondary = active ? "var(--color-gold-600)" : "var(--color-base-600)";
  
  return (
    <motion.svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none"
      className={className}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      <path 
        d="M4 4C4 2.89543 4.89543 2 6 2H14L20 8V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4Z" 
        fill={secondary}
      />
      <path 
        d="M14 2L20 8H16C14.8954 8 14 7.10457 14 6V2Z" 
        fill={primary}
      />
      <path 
        d="M8 13H16M8 17H13" 
        stroke={primary} 
        strokeWidth="2" 
        strokeLinecap="round"
      />
    </motion.svg>
  );
}

export function IconCharacters({ className = "", size = 24, active = false }) {
  const primary = active ? "var(--color-gold-400)" : "var(--text-secondary)";
  const secondary = active ? "var(--color-gold-600)" : "var(--color-base-600)";
  
  return (
    <motion.svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none"
      className={className}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      <circle cx="9" cy="7" r="4" fill={primary} />
      <path 
        d="M3 21V19C3 16.7909 4.79086 15 7 15H11C13.2091 15 15 16.7909 15 19V21" 
        fill={secondary}
      />
      <circle cx="17" cy="8" r="3" fill={secondary} />
      <path 
        d="M15 21V19.5C15 18.5 15.5 17 17 16C18 15.5 19 15.5 20 16C21 16.5 21 18 21 19V21" 
        fill={primary}
        opacity="0.7"
      />
    </motion.svg>
  );
}

export function IconLocations({ className = "", size = 24, active = false }) {
  const primary = active ? "var(--color-gold-400)" : "var(--text-secondary)";
  const secondary = active ? "var(--color-gold-600)" : "var(--color-base-600)";
  
  return (
    <motion.svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none"
      className={className}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      <path 
        d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2Z" 
        fill={secondary}
      />
      <circle cx="12" cy="9" r="3" fill={primary} />
    </motion.svg>
  );
}

export function IconScenes({ className = "", size = 24, active = false }) {
  const primary = active ? "var(--color-gold-400)" : "var(--text-secondary)";
  const secondary = active ? "var(--color-gold-600)" : "var(--color-base-600)";
  
  return (
    <motion.svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none"
      className={className}
      whileHover={{ scale: 1.1, rotate: -5 }}
      whileTap={{ scale: 0.95 }}
    >
      {/* Clapperboard base */}
      <path 
        d="M4 8C4 6.89543 4.89543 6 6 6H18C19.1046 6 20 6.89543 20 8V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V8Z" 
        fill={secondary}
      />
      {/* Clapperboard top */}
      <path 
        d="M4 6L6 3H18L20 6H4Z" 
        fill={primary}
      />
      {/* Stripes */}
      <path d="M6 3L8 6" stroke={secondary} strokeWidth="1.5" />
      <path d="M10 3L12 6" stroke={secondary} strokeWidth="1.5" />
      <path d="M14 3L16 6" stroke={secondary} strokeWidth="1.5" />
    </motion.svg>
  );
}

export function IconStoryboard({ className = "", size = 24, active = false }) {
  const primary = active ? "var(--color-gold-400)" : "var(--text-secondary)";
  const secondary = active ? "var(--color-gold-600)" : "var(--color-base-600)";
  
  return (
    <motion.svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none"
      className={className}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      {/* Film strip */}
      <rect x="2" y="4" width="20" height="16" rx="2" fill={secondary} />
      {/* Sprocket holes */}
      <rect x="4" y="6" width="2" height="2" rx="0.5" fill={primary} />
      <rect x="4" y="10" width="2" height="2" rx="0.5" fill={primary} />
      <rect x="4" y="14" width="2" height="2" rx="0.5" fill={primary} />
      <rect x="18" y="6" width="2" height="2" rx="0.5" fill={primary} />
      <rect x="18" y="10" width="2" height="2" rx="0.5" fill={primary} />
      <rect x="18" y="14" width="2" height="2" rx="0.5" fill={primary} />
      {/* Frame */}
      <rect x="8" y="7" width="8" height="10" rx="1" fill={primary} />
      {/* Play icon */}
      <path d="M11 10L14 12L11 14V10Z" fill={secondary} />
    </motion.svg>
  );
}

export function IconPlus({ className = "", size = 24 }) {
  return (
    <motion.svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none"
      className={className}
      whileHover={{ scale: 1.1, rotate: 90 }}
      whileTap={{ scale: 0.95 }}
    >
      <circle cx="12" cy="12" r="10" fill="var(--color-gold-500)" />
      <path 
        d="M12 7V17M7 12H17" 
        stroke="var(--color-base-950)" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
    </motion.svg>
  );
}

export function IconSparkle({ className = "", size = 24, animate = false }) {
  return (
    <motion.svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none"
      className={className}
      animate={animate ? { rotate: [0, 15, -15, 0], scale: [1, 1.1, 1] } : {}}
      transition={{ duration: 2, repeat: Infinity }}
    >
      <path 
        d="M12 2L14.5 9.5L22 12L14.5 14.5L12 22L9.5 14.5L2 12L9.5 9.5L12 2Z" 
        fill="var(--color-gold-400)"
      />
    </motion.svg>
  );
}

export function IconCamera({ className = "", size = 24 }) {
  return (
    <motion.svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none"
      className={className}
      whileHover={{ scale: 1.1 }}
    >
      <rect x="2" y="6" width="20" height="14" rx="3" fill="var(--color-base-600)" />
      <circle cx="12" cy="13" r="4" fill="var(--color-gold-400)" />
      <circle cx="12" cy="13" r="2" fill="var(--color-base-600)" />
      <rect x="6" y="3" width="4" height="3" rx="1" fill="var(--color-base-600)" />
    </motion.svg>
  );
}

export function IconImage({ className = "", size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <rect x="3" y="3" width="18" height="18" rx="3" fill="var(--color-base-600)" />
      <circle cx="8.5" cy="8.5" r="2.5" fill="var(--color-gold-400)" />
      <path d="M3 15L8 11L11 14L16 9L21 14V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V15Z" fill="var(--color-gold-500)" />
    </svg>
  );
}

export function IconFolder({ className = "", size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M2 6C2 4.89543 2.89543 4 4 4H9L11 6H20C21.1046 6 22 6.89543 22 8V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6Z" fill="var(--color-base-600)" />
      <path d="M2 10H22V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V10Z" fill="var(--color-gold-500)" opacity="0.5" />
    </svg>
  );
}

export function IconSearch({ className = "", size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <circle cx="11" cy="11" r="7" fill="var(--color-base-700)" />
      <circle cx="11" cy="11" r="4" fill="var(--color-base-600)" />
      <path d="M16 16L21 21" stroke="var(--text-muted)" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}

export function IconSettings({ className = "", size = 24 }) {
  return (
    <motion.svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none"
      className={className}
      whileHover={{ rotate: 45 }}
      transition={{ duration: 0.3 }}
    >
      <circle cx="12" cy="12" r="3" fill="var(--color-gold-400)" />
      <path d="M12 1V4M12 20V23M4.22 4.22L6.34 6.34M17.66 17.66L19.78 19.78M1 12H4M20 12H23M4.22 19.78L6.34 17.66M17.66 6.34L19.78 4.22" stroke="var(--color-base-500)" strokeWidth="2" strokeLinecap="round" />
    </motion.svg>
  );
}

export function IconTrash({ className = "", size = 24 }) {
  return (
    <motion.svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none"
      className={className}
      whileHover={{ scale: 1.1 }}
    >
      <path d="M5 7H19L18 21H6L5 7Z" fill="var(--color-error)" opacity="0.3" />
      <path d="M9 3H15V5H9V3Z" fill="var(--color-error)" />
      <path d="M3 5H21V7H3V5Z" fill="var(--color-error)" />
      <path d="M10 10V17M14 10V17" stroke="var(--color-error)" strokeWidth="1.5" strokeLinecap="round" />
    </motion.svg>
  );
}

export function IconChevronRight({ className = "", size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconCheck({ className = "", size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <circle cx="12" cy="12" r="10" fill="var(--color-success)" />
      <path d="M8 12L11 15L16 9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconWarning({ className = "", size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M12 2L22 20H2L12 2Z" fill="var(--color-warning)" />
      <path d="M12 10V14M12 17V17.5" stroke="var(--color-base-950)" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function IconLogo({ className = "", size = 32 }) {
  return (
    <motion.svg 
      width={size} 
      height={size} 
      viewBox="0 0 32 32" 
      fill="none"
      className={className}
      whileHover={{ rotate: 360 }}
      transition={{ duration: 0.8, ease: "easeInOut" }}
    >
      {/* Outer ring */}
      <circle cx="16" cy="16" r="14" stroke="var(--color-gold-500)" strokeWidth="2" />
      {/* Inner film reel */}
      <circle cx="16" cy="16" r="6" fill="var(--color-gold-500)" />
      <circle cx="16" cy="16" r="3" fill="var(--color-base-950)" />
      {/* Sprocket holes */}
      {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => (
        <circle
          key={i}
          cx={16 + 10 * Math.cos((angle * Math.PI) / 180)}
          cy={16 + 10 * Math.sin((angle * Math.PI) / 180)}
          r="1.5"
          fill="var(--color-gold-400)"
        />
      ))}
    </motion.svg>
  );
}


export function IconSchedule({ className = "", size = 24, active = false }) {
  const primary = active ? "var(--color-gold-400)" : "var(--text-secondary)";
  const secondary = active ? "var(--color-gold-600)" : "var(--color-base-600)";
  return (
    <motion.svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
      <rect x="3" y="4" width="18" height="18" rx="3" fill={secondary} />
      <rect x="3" y="4" width="18" height="6" rx="3" fill={primary} />
      <circle cx="8" cy="15" r="1.5" fill={primary} />
      <circle cx="12" cy="15" r="1.5" fill={primary} />
      <circle cx="16" cy="15" r="1.5" fill={primary} />
      <rect x="7" y="2" width="2" height="4" rx="1" fill={primary} />
      <rect x="15" y="2" width="2" height="4" rx="1" fill={primary} />
    </motion.svg>
  );
}

export function IconBudget({ className = "", size = 24, active = false }) {
  const primary = active ? "var(--color-gold-400)" : "var(--text-secondary)";
  const secondary = active ? "var(--color-gold-600)" : "var(--color-base-600)";
  return (
    <motion.svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
      <rect x="2" y="6" width="20" height="14" rx="3" fill={secondary} />
      <path d="M2 10H22" stroke={primary} strokeWidth="2" />
      <rect x="14" y="14" width="5" height="3" rx="1" fill={primary} />
      <circle cx="12" cy="4" r="2" fill={primary} />
    </motion.svg>
  );
}

export function IconTeam({ className = "", size = 24, active = false }) {
  const primary = active ? "var(--color-gold-400)" : "var(--text-secondary)";
  const secondary = active ? "var(--color-gold-600)" : "var(--color-base-600)";
  return (
    <motion.svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
      <circle cx="12" cy="8" r="4" fill={primary} />
      <path d="M4 20C4 16.6863 6.68629 14 10 14H14C17.3137 14 20 16.6863 20 20V21H4V20Z" fill={secondary} />
      <circle cx="19" cy="8" r="2.5" fill={secondary} />
      <circle cx="5" cy="8" r="2.5" fill={secondary} />
    </motion.svg>
  );
}


export function IconVault({ className = "", size = 24, active = false }) {
  const primary = active ? "var(--color-gold-400)" : "var(--text-secondary)";
  const secondary = active ? "var(--color-gold-600)" : "var(--color-base-600)";
  return (
    <motion.svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      {/* Vault door - rounded rect with thick border */}
      <rect x="3" y="4" width="18" height="17" rx="3" fill={secondary} />
      {/* Inner panel */}
      <rect x="5" y="6" width="14" height="13" rx="2" fill="var(--color-base-950)" opacity="0.4" />
      {/* Combination dial - outer ring */}
      <circle cx="12" cy="12.5" r="4.5" stroke={primary} strokeWidth="1.5" fill="none" />
      {/* Dial center */}
      <circle cx="12" cy="12.5" r="1.5" fill={primary} />
      {/* Dial notches */}
      <path d="M12 8V9.5" stroke={primary} strokeWidth="1" strokeLinecap="round" />
      <path d="M12 15.5V17" stroke={primary} strokeWidth="1" strokeLinecap="round" />
      <path d="M7.5 12.5H9" stroke={primary} strokeWidth="1" strokeLinecap="round" />
      <path d="M15 12.5H16.5" stroke={primary} strokeWidth="1" strokeLinecap="round" />
      {/* Handle bar on right */}
      <rect x="19" y="10" width="2" height="5" rx="1" fill={primary} />
      {/* Hinges on left */}
      <rect x="3" y="7" width="1.5" height="2" rx="0.5" fill={primary} opacity="0.6" />
      <rect x="3" y="16" width="1.5" height="2" rx="0.5" fill={primary} opacity="0.6" />
      {/* Film reel mark inside dial - 1895 identity */}
      <circle cx="12" cy="12.5" r="3" stroke={primary} strokeWidth="0.5" strokeDasharray="1.5 1.5" opacity="0.5" />
    </motion.svg>
  );
}

export function IconStudio({ className = "", size = 24, active = false }) {
  const primary = active ? "var(--color-gold-400)" : "var(--text-secondary)";
  const secondary = active ? "var(--color-gold-600)" : "var(--color-base-600)";
  return (
    <motion.svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
      <path d="M3 7L12 3L21 7V17L12 21L3 17V7Z" fill={secondary} />
      <path d="M3 7L12 11L21 7" stroke={primary} strokeWidth="1.5" />
      <path d="M12 11V21" stroke={primary} strokeWidth="1.5" />
      <circle cx="12" cy="11" r="2" fill={primary} />
      <path d="M7 5L12 7.5L17 5" stroke={primary} strokeWidth="1" opacity="0.5" />
    </motion.svg>
  );
}


export function IconGreenlight({ className = "", size = 24, active = false }) {
  const primary = active ? "var(--color-gold-400)" : "var(--text-secondary)";
  const secondary = active ? "var(--color-gold-600)" : "var(--color-base-600)";
  return (
    <motion.svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
      {/* Traffic light body */}
      <rect x="7" y="2" width="10" height="20" rx="3" fill={secondary} />
      {/* Green light (bottom) — the greenlight */}
      <circle cx="12" cy="17" r="2.5" fill={active ? "#4CAF50" : primary} />
      {/* Yellow light (middle) */}
      <circle cx="12" cy="12" r="2" fill={secondary} opacity="0.5" />
      {/* Red light (top) */}
      <circle cx="12" cy="7" r="2" fill={secondary} opacity="0.3" />
      {/* Shine on green */}
      <circle cx="11" cy="16" r="0.8" fill="white" opacity={active ? "0.4" : "0"} />
    </motion.svg>
  );
}

// ─── Stage Badge Icons (replace emojis) ─────────────────────────────────────

export function IconSketchBadge({ size = 14, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" className={className}>
      <path d="M11.5 2.5L13.5 4.5L5.5 12.5L2.5 13.5L3.5 10.5L11.5 2.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 4L12 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

export function IconConceptBadge({ size = 14, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" className={className}>
      <circle cx="6" cy="10" r="3" stroke="currentColor" strokeWidth="1.5"/>
      <circle cx="10" cy="6" r="3" stroke="currentColor" strokeWidth="1.5"/>
      <circle cx="10" cy="10" r="3" stroke="currentColor" strokeWidth="1.5" opacity="0.5"/>
    </svg>
  );
}

export function IconPrevisBadge({ size = 14, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" className={className}>
      <rect x="2" y="3" width="12" height="10" rx="2" stroke="currentColor" strokeWidth="1.5"/>
      <circle cx="8" cy="8" r="2.5" stroke="currentColor" strokeWidth="1.5"/>
      <circle cx="8" cy="8" r="1" fill="currentColor"/>
    </svg>
  );
}
